/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchPoolsResponse } from './search-pools-response';


export interface SearchPoolsResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchPoolsResponse> | null;
}

